<template>
    <v-container>
        <v-row
            class="mb-6"
            justify="center"
            no-gutters
        >
            <v-col
                xs="10"
                sm="8"
                md="6"
                lg="4"
            >
                <div class="d-flex justify-center">
                    <PlayerChip />
                </div>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col
                xs="12"
                md="10"
            >
                <p>{{ this.artists[$route.params.artistId].artistInfo }}</p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PlayerChip from './parts/PlayerChip';

export default {
    name: 'Artist',
    props: {},
    data() {
        return {
            artists: [
                {
                    artistInfo: 'Arezra est un jeune DJ américain qui s\'est fait connaitre en 2020'
                },
                {
                    artistInfo: 'DVBBS est un duo canadien de musique électronique, formé en 2012 par les deux frères Chris Andre et Alex Andre. Le duo est mondialement connu pour son single Tsunami réalisé en collaboration avec le musicien américain Borgeous.',
                },
                {
                    artistInfo: 'System of a Down est un groupe de rock américain, originaire de Californie. Formé en 1994, le groupe est actuellement composé de quatre membres, ayant tous des origines arméniennes : Daron Malakian, Serj Tankian, Shavo Odadjian et John Dolmayan.',
                },
                {
                    artistInfo: 'Founded in 2018 the Berlin based project VIZE by producer Vitali and deejay Johannes conquered the world of electronic dance music! With 12.700.000 monthly listeners on Spotify, 150.000.000 YouTube views, over 750.000.000 streams and all singles in the German Top 50, VIZE is undoubtedly one of the most successful act within the scene of electronic music.',
                }
            ]
        };
    },
    components: {
        PlayerChip
    },
    methods: {},
};
</script>

<style lang="scss">
</style>
